import { render, staticRenderFns } from "./SiteProps.vue?vue&type=template&id=150863a8"
import script from "./SiteProps.vue?vue&type=script&lang=js"
export * from "./SiteProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports